import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CurrentUser } from 'types'

/**
 * Extended CurrentUser type with computed admin properties
 */
export interface CurrentUserWithAdminFlags extends CurrentUser {
  isCssAdmin: boolean
  isTechnologyAdmin: boolean
  isOperationsAdmin: boolean
  isAdmin: boolean
  notifications?: { color: string; text: string }[]
}

export interface CurrentUserManagerState {
  isLoading: boolean
  currentUser?: CurrentUserWithAdminFlags
  currentUserFetchedAt?: Date
  error?: string
  isUpdating: boolean
  updateSuccess: boolean
  updateError?: string
}

const initialState: CurrentUserManagerState = {
  isLoading: false,
  currentUser: null,
  currentUserFetchedAt: null,
  error: null,
  isUpdating: false,
  updateSuccess: false,
  updateError: null,
}

const slice = createSlice({
  name: 'currentUserManager',
  initialState,
  reducers: {
    fetchingCurrentUser(state) {
      state.isLoading = true
      state.error = null
    },
    fetchCurrentUserSuccess(
      state,
      action: PayloadAction<CurrentUserWithAdminFlags>,
    ) {
      state.isLoading = false
      state.currentUser = action.payload
      state.currentUserFetchedAt = new Date()
      state.error = null
    },
    fetchCurrentUserError(state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    },
    clearCurrentUser(state) {
      state.currentUser = null
      state.currentUserFetchedAt = null
      state.error = null
      state.isLoading = false
    },
    updatingUserProfile(state) {
      state.isUpdating = true
      state.updateSuccess = false
      state.updateError = null
    },
    updateUserProfileSuccess(state) {
      state.isUpdating = false
      state.updateSuccess = true
      state.updateError = null
    },
    updateUserProfileError(state, action: PayloadAction<string>) {
      state.isUpdating = false
      state.updateSuccess = false
      state.updateError = action.payload
    },
    clearUpdateStatus(state) {
      state.isUpdating = false
      state.updateSuccess = false
      state.updateError = null
    },
  },
})

export const actions = slice.actions
export default slice.reducer
